module.exports = __webpack_public_path__ + "img/hr-artillery-wagon-cannon-base-1.3f72d4a7.png";